//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import OrgSelect from "@/components/Org/OrgSelect";
import manage from '@/constants/manage';
export default {
  // components: { OrgSelect },
  data: function data() {
    return {
      ruleForm: {
        userName: '',
        affiliation: [],
        position: '',
        information: '',
        status: '',
        coreOrgNumber: '',
        orgNumber: ''
      },
      rules: {
        userName: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 5,
          message: '长度在 3 到 5 个字符',
          trigger: 'blur'
        }],
        affiliation: [{
          required: true,
          message: '请选择用户所属机构',
          trigger: 'change'
        }],
        date1: [{
          type: 'date',
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        date2: [{
          type: 'date',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        type: [{
          type: 'array',
          required: true,
          message: '请至少选择一个活动性质',
          trigger: 'change'
        }],
        resource: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }],
        desc: [{
          required: true,
          message: '请填写活动形式',
          trigger: 'blur'
        }]
      },
      orgId: '100001',
      defaultCheckedKeyArr: [],
      showOrg: false,
      topId: manage.HEAD_ORG_ID
    };
  },
  methods: {
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(function (valid) {
        if (!valid) {
          return false;
        }
      });
    },
    cancelFn: function cancelFn() {},
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeOrgFn: function closeOrgFn(obj) {
      this.showOrg = false;
      //  根据obj.bool 判断是确认   还是取消    关闭的弹窗
      if (obj.bool) {
        this.ruleForm.affiliation = JSON.parse(JSON.stringify(obj.selectdOrgArr));
      }
    },
    showOrgDialog: function showOrgDialog() {
      this.showOrg = true;
    }
  }
};